import { useState } from 'react';
import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';
import { getAuthHeader } from '#lib/hooks/use-auth.jsx';

const fetchImages = async (query, page, lang, library) => {
    const authHeaders = await getAuthHeader();

    return await fetchAndParse(`${API_URL}/p/libraryImage`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify({ query, page, lang, library })
    });
};

export function useImageLibrary({ multiple = false, lang }) {
    const libraries = ['unsplash', 'pexels', 'adobe', 'pixabay'];

    const [images, setImages] = useState([]);
    const [selectedImages, setSelectedImages] = useState([]);
    const [currentLibrary, setCurrentLibrary] = useState('unsplash');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [lastSearch, setLastSearch] = useState({ lastQuery: '', lastPage: 0, lastLibrary: '' });
    const { lastQuery, lastPage, lastLibrary } = lastSearch;

    const handleSelectLibrary = (library) => {
        setCurrentLibrary(library);
    };

    const fetchImagesFromLibrary = async (query, page) => {
        setError(null);
        if (page === lastPage && currentLibrary === lastLibrary && query === lastQuery) {
            return;
        }
        setLoading(true);
        try {
            const res = await fetchImages(query, page, lang, currentLibrary);
            console.log(res)
            if (query !== lastQuery || currentLibrary !== lastLibrary) {
                setImages(res.images);
            } else setImages((prev) => prev.concat(res.images));
            setLastSearch({ lastQuery: query, lastPage: page, lastLibrary: currentLibrary });
        } catch (e) {
            setError(e.message);
        }
        setLoading(false);
    };

    const selectImage = (image) => {
        const sourceType = currentLibrary === 'pixabay' ? 'I' : 'L';
        const selectedImage = { ...image, sourceType }
        if (multiple) {
            setSelectedImages((prev) => {
                const newImages = [...prev];
                const index = newImages.findIndex((img) => img.id === selectedImage.id);
                if (index === -1) {
                    newImages.push(selectedImage);
                } else {
                    newImages.splice(index, 1);
                }
                return newImages;
            });
        }
        if (!multiple) {
            setSelectedImages([selectedImage]);
        }
    };

    const clearImages = () => {
        setImages([]);
    };

    const clearSearch = () => {
        setLastSearch({ lastQuery: '', lastPage: 0, lastLibrary: '' });
    };

    const clearAll = () => {
        clearImages();
        clearSearch();
        setSelectedImages([]);
    };

    return {
        lastSearch,
        currentLibrary,
        libraries,
        images,
        selectedImages,
        loading,
        error,
        handleSelectLibrary,
        fetchImagesFromLibrary,
        selectImage,
        clearImages,
        clearSearch,
        clearAll
    };
}
